// @ts-nocheck

//////////////////////////////////////
//   This file is auto generated   //
//////////////////////////////////////

import * as System from "./System"
import * as Theasoft_DataClasses_Personal from "./Theasoft_DataClasses_Personal"
import * as System_Collections_Generic from "./System_Collections_Generic"
import * as Theasoft_DataClasses_Dispo from "./Theasoft_DataClasses_Dispo"
import * as Theasoft_DataTypes_Enums from "./Theasoft_DataTypes_Enums"
import * as Theasoft_DataClasses_Perso from "./Theasoft_DataClasses_Perso"
import * as Theasoft_DataClasses_Connection from "./Theasoft_DataClasses_Connection"
import * as Theasoft_DataClasses from "./Theasoft_DataClasses"
import * as System_Collections_ObjectModel from "./System_Collections_ObjectModel"

export type SQLRight = "ciUnknown" | "ciAccessRightNo" | "ciAccessRightRead" | "ciAccessRightWrite" | "ciAccessRightUpdate" | "ciAccessRightExecute"
export const SQLRight_AllValues = ["ciUnknown", "ciAccessRightNo", "ciAccessRightRead", "ciAccessRightWrite", "ciAccessRightUpdate", "ciAccessRightExecute"] as const
export const defaultSQLRight: SQLRight = "ciUnknown"

export type VacantCastCalculation = "None" | "RoleFee" | "BasicCast" | "RoleTypeSalaryRule"
export const VacantCastCalculation_AllValues = ["None", "RoleFee", "BasicCast", "RoleTypeSalaryRule"] as const
export const defaultVacantCastCalculation: VacantCastCalculation = "None"

export type ts_DataOwnerGroup = {
  ownerGroupId: System.Int32
  name: System.String
  sort: System.Int32
  defaultPerformanceCastStatus: Theasoft_DataClasses_Dispo.ts_DataCastStatus
  writableContractCostCenter: System_Collections_Generic.List<Theasoft_DataClasses_Dispo.ts_DataCostCenter>
  departments: System_Collections_Generic.List<Theasoft_DataClasses_Perso.ts_DataDepartment>
  webPublishLockingDate: System.DateTime
  modul: Theasoft_DataClasses.ts_Module
  resourceModule: Theasoft_DataClasses.ts_Module
  isSoloist: System.Boolean
  isArtistic: System.Boolean
  isPublicGroup: System.Boolean
  countDownDate: System.DateTime
  defaultPerformanceCastStatusId: System.Int32
  defaultActivityStatus: Theasoft_DataClasses_Dispo.ts_DataActivityStatus
  defaultActivityStatusId: System.Int32
  mainOwnerGroupId: System.Nullable<System.Int32>
  vacantCastCalculationBy: VacantCastCalculation
  basicCastPerSeason: System.Boolean
  description: System.String
  mainOwnerGroup: ts_DataOwnerGroup
  activityPublishingStatusRuleSettings: System.String
  activityPublishingStatusRules: Theasoft_DataClasses_Dispo.ActivityPublishingStatusRules
  ownerGroupWithChild: System_Collections_Generic.IEnumerable<ts_DataOwnerGroup>
  connection: Theasoft_DataClasses_Connection.TsDBA
  deleteFlag: System.Boolean
  permission: SQLRight
  isNew: System.Boolean
  isLocked: System.Boolean
  isNewDirtyDeleteFlag: System.Boolean
  isDirty: System.Boolean
  primaryKeyValue: System.Int32
  displayValue: System.String
  createAt: System.DateTime
  createAtValue: System.String
  userCreateId: System.Nullable<System.Int32>
  lastModifiedValue: System.String
  lastModified: System.DateTime
  userModifiedId: System.Nullable<System.Int32>
  userNameModified: System.String
  userNameCreate: System.String
  userCreate: ts_DataUser
  personCreate: Theasoft_DataClasses_Personal.ts_DataPerson
  personModified: Theasoft_DataClasses_Personal.ts_DataPerson
  userModified: ts_DataUser
  classInfo: System.String
  idInfo: System.String
  createInfo: System.String
  modifiedInfo: System.String
  isDeleted: System.Boolean
  userContext: ts_DataUser
}

export type ts_DataComputer = {
  computerId: System.Int32
  name: System.String
  theasoftVersionString: System.String
  computerVersion: System.Version
  theasoftVersion: System.Version
  osVersion: System.String
  osInfo: System.String
  isAutoUpdateEnabled: System.Boolean
  autoUpdatePath: System.String
  frameworkInfo: System.String
  frameworkVersion: System.String
  netFrameworkVersion: System.Version
  connection: Theasoft_DataClasses_Connection.TsDBA
  deleteFlag: System.Boolean
  permission: SQLRight
  isNew: System.Boolean
  isLocked: System.Boolean
  isNewDirtyDeleteFlag: System.Boolean
  isDirty: System.Boolean
  primaryKeyValue: System.Int32
  displayValue: System.String
  createAt: System.DateTime
  createAtValue: System.String
  userCreateId: System.Nullable<System.Int32>
  lastModifiedValue: System.String
  lastModified: System.DateTime
  userModifiedId: System.Nullable<System.Int32>
  userNameModified: System.String
  userNameCreate: System.String
  userCreate: ts_DataUser
  personCreate: Theasoft_DataClasses_Personal.ts_DataPerson
  personModified: Theasoft_DataClasses_Personal.ts_DataPerson
  userModified: ts_DataUser
  classInfo: System.String
  idInfo: System.String
  createInfo: System.String
  modifiedInfo: System.String
  isDeleted: System.Boolean
  userContext: ts_DataUser
}

export type GroupRight = "Read" | "Write" | "No"
export const GroupRight_AllValues = ["Read", "Write", "No"] as const
export const defaultGroupRight: GroupRight = "Read"

export type ts_PermissionArea = "Kontaktdaten" | "Vertragsdaten" | "Dispodaten" | "Productions" | "Cast" | "DutyRoster" | "BodyMeasure" | "Payment" | "PersStatus" | "ActivityTypes" | "Tours" | "PlanEditing" | "Order" | "PersonAttachments" | "Exports" | "Travels" | "Resources" | "Checklists" | "Auditions" | "Reminders" | "ProjectPlan" | "ProductionAttachments" | "CostPlans" | "Invoices" | "DashboardFiles" | "ActivityAttachments"
export const ts_PermissionArea_AllValues = ["Kontaktdaten", "Vertragsdaten", "Dispodaten", "Productions", "Cast", "DutyRoster", "BodyMeasure", "Payment", "PersStatus", "ActivityTypes", "Tours", "PlanEditing", "Order", "PersonAttachments", "Exports", "Travels", "Resources", "Checklists", "Auditions", "Reminders", "ProjectPlan", "ProductionAttachments", "CostPlans", "Invoices", "DashboardFiles", "ActivityAttachments"] as const
export const defaultts_PermissionArea: ts_PermissionArea = "Kontaktdaten"

export type ts_DataPermission = {
  hasWriteRight: System.Boolean
  isInherited: System.Boolean
  hasWritePermission: GroupRight
  userId: System.Int32
  user: ts_DataUser
  ownerGroupId: System.Int32
  optionsFlag: System.Int32
  optionsFlagText: System.String
  optionsType: System.Type
  ownerGroup: ts_DataOwnerGroup
  permissionArea: ts_PermissionArea
  permissionId: System.Int32
  options: System.String
  connection: Theasoft_DataClasses_Connection.TsDBA
  deleteFlag: System.Boolean
  permission: SQLRight
  isNew: System.Boolean
  isLocked: System.Boolean
  isNewDirtyDeleteFlag: System.Boolean
  isDirty: System.Boolean
  primaryKeyValue: System.Int32
  displayValue: System.String
  createAt: System.DateTime
  createAtValue: System.String
  userCreateId: System.Nullable<System.Int32>
  lastModifiedValue: System.String
  lastModified: System.DateTime
  userModifiedId: System.Nullable<System.Int32>
  userNameModified: System.String
  userNameCreate: System.String
  userCreate: ts_DataUser
  personCreate: Theasoft_DataClasses_Personal.ts_DataPerson
  personModified: Theasoft_DataClasses_Personal.ts_DataPerson
  userModified: ts_DataUser
  classInfo: System.String
  idInfo: System.String
  createInfo: System.String
  modifiedInfo: System.String
  isDeleted: System.Boolean
  userContext: ts_DataUser
}

export type ts_DataUserGroupMember = {
  userGroupMemberId: System.Int32
  userId: System.Int32
  userGroupId: System.Int32
  user: ts_DataUser
  userGroup: ts_DataUser
  isInherited: System.Boolean
  connection: Theasoft_DataClasses_Connection.TsDBA
  deleteFlag: System.Boolean
  permission: SQLRight
  isNew: System.Boolean
  isLocked: System.Boolean
  isNewDirtyDeleteFlag: System.Boolean
  isDirty: System.Boolean
  primaryKeyValue: System.Int32
  displayValue: System.String
  createAt: System.DateTime
  createAtValue: System.String
  userCreateId: System.Nullable<System.Int32>
  lastModifiedValue: System.String
  lastModified: System.DateTime
  userModifiedId: System.Nullable<System.Int32>
  userNameModified: System.String
  userNameCreate: System.String
  userCreate: ts_DataUser
  personCreate: Theasoft_DataClasses_Personal.ts_DataPerson
  personModified: Theasoft_DataClasses_Personal.ts_DataPerson
  userModified: ts_DataUser
  classInfo: System.String
  idInfo: System.String
  createInfo: System.String
  modifiedInfo: System.String
  isDeleted: System.Boolean
  userContext: ts_DataUser
}

export type ts_DataUserManagedGroups = {
  userManagedGroupId: System.Int32
  userId: System.Int32
  userGroupId: System.Int32
  user: ts_DataUser
  userGroup: ts_DataUser
  isInherited: System.Boolean
  connection: Theasoft_DataClasses_Connection.TsDBA
  deleteFlag: System.Boolean
  permission: SQLRight
  isNew: System.Boolean
  isLocked: System.Boolean
  isNewDirtyDeleteFlag: System.Boolean
  isDirty: System.Boolean
  primaryKeyValue: System.Int32
  displayValue: System.String
  createAt: System.DateTime
  createAtValue: System.String
  userCreateId: System.Nullable<System.Int32>
  lastModifiedValue: System.String
  lastModified: System.DateTime
  userModifiedId: System.Nullable<System.Int32>
  userNameModified: System.String
  userNameCreate: System.String
  userCreate: ts_DataUser
  personCreate: Theasoft_DataClasses_Personal.ts_DataPerson
  personModified: Theasoft_DataClasses_Personal.ts_DataPerson
  userModified: ts_DataUser
  classInfo: System.String
  idInfo: System.String
  createInfo: System.String
  modifiedInfo: System.String
  isDeleted: System.Boolean
  userContext: ts_DataUser
}

export type ts_DataUserFeature = {
  userFeatureId: System.Int32
  userId: System.Int32
  featureId: System.String
  isAvailable: System.Boolean
  isInherited: System.Boolean
  connection: Theasoft_DataClasses_Connection.TsDBA
  deleteFlag: System.Boolean
  permission: SQLRight
  isNew: System.Boolean
  isLocked: System.Boolean
  isNewDirtyDeleteFlag: System.Boolean
  isDirty: System.Boolean
  primaryKeyValue: System.Int32
  displayValue: System.String
  createAt: System.DateTime
  createAtValue: System.String
  userCreateId: System.Nullable<System.Int32>
  lastModifiedValue: System.String
  lastModified: System.DateTime
  userModifiedId: System.Nullable<System.Int32>
  userNameModified: System.String
  userNameCreate: System.String
  userCreate: ts_DataUser
  personCreate: Theasoft_DataClasses_Personal.ts_DataPerson
  personModified: Theasoft_DataClasses_Personal.ts_DataPerson
  userModified: ts_DataUser
  classInfo: System.String
  idInfo: System.String
  createInfo: System.String
  modifiedInfo: System.String
  isDeleted: System.Boolean
  userContext: ts_DataUser
}

export type ts_DataUserFeatureDefault = {
  userFeatureDefaultId: System.Int32
  userId: System.Int32
  isAvailable: System.Boolean
  isInherited: System.Boolean
  connection: Theasoft_DataClasses_Connection.TsDBA
  deleteFlag: System.Boolean
  permission: SQLRight
  isNew: System.Boolean
  isLocked: System.Boolean
  isNewDirtyDeleteFlag: System.Boolean
  isDirty: System.Boolean
  primaryKeyValue: System.Int32
  displayValue: System.String
  createAt: System.DateTime
  createAtValue: System.String
  userCreateId: System.Nullable<System.Int32>
  lastModifiedValue: System.String
  lastModified: System.DateTime
  userModifiedId: System.Nullable<System.Int32>
  userNameModified: System.String
  userNameCreate: System.String
  userCreate: ts_DataUser
  personCreate: Theasoft_DataClasses_Personal.ts_DataPerson
  personModified: Theasoft_DataClasses_Personal.ts_DataPerson
  userModified: ts_DataUser
  classInfo: System.String
  idInfo: System.String
  createInfo: System.String
  modifiedInfo: System.String
  isDeleted: System.Boolean
  userContext: ts_DataUser
}

export type PrincipalAuthenticationType = "None" | "Instance" | "Database" | "Windows" | "External"
export const PrincipalAuthenticationType_AllValues = ["None", "Instance", "Database", "Windows", "External"] as const
export const defaultPrincipalAuthenticationType: PrincipalAuthenticationType = "None"

export type DatabasePrincipalInfo = {
  sid: System_Collections_ObjectModel.ReadOnlyCollection<System.Byte>
  userName: System.String
  principleType: System.Char
  isEmpty: System.Boolean
  isWindowsUser: System.Boolean
  isWindowsGroup: System.Boolean
  isSqlUser: System.Boolean
  isDatabaseRole: System.Boolean
  authenticationType: PrincipalAuthenticationType
}

export type ts_DataUser = {
  isDbo: System.Boolean
  isSaTheasoft: System.Boolean
  userID: System.Int32
  personId: System.Nullable<System.Int32>
  persObject: Theasoft_DataClasses_Personal.ts_DataPerson
  primaryOwnerGroupId: System.Nullable<System.Int32>
  primaerGruppe: ts_DataOwnerGroup
  isInactive: System.Boolean
  lastLoginComputerId: System.Nullable<System.Int32>
  lastLoginDate: System.Nullable<System.DateTime>
  hasDatabaseUserOrIsTheasoftAuthorizationUser: System.Boolean
  lastLoginComputer: ts_DataComputer
  fullUserName: System.String
  userNamWithStatus: System.String
  pureUsername: System.String
  isWindowsUser: System.Boolean
  userName: System.String
  isPublic: System.Boolean
  displayName: System.String
  plainDisplayName: System.String
  isGroup: System.Boolean
  isUser: System.Boolean
  isDatabaseRole: System.Boolean
  isUserGroup: System.Boolean
  isAuthorizedByWindowsGroup: System.Boolean
  userGroups: System_Collections_Generic.IList<ts_DataPermission>
  userGroupMembers: System_Collections_Generic.IList<ts_DataUserGroupMember>
  groupsOwnedByUser: System_Collections_Generic.IList<ts_DataUserManagedGroups>
  userFeatures: System_Collections_Generic.IList<ts_DataUserFeature>
  userFeatureDefault: ts_DataUserFeatureDefault
  memberOfGroupsOfSelf: System_Collections_Generic.HashSet<System.Int32>
  memberOfGroups: System_Collections_Generic.IList<ts_DataUser>
  passwordHash: System.String
  email: System.String
  usersOfGroup: System_Collections_Generic.IList<ts_DataUser>
  winUserName: System.String
  principalInfo: DatabasePrincipalInfo
  seasonUser: System_Collections_Generic.IList<Theasoft_DataClasses_Dispo.ts_DataSeasonPermission>
  seasons: System_Collections_Generic.List<Theasoft_DataClasses_Dispo.ts_DataSeason>
  permissionDictionary: System_Collections_Generic.Dictionary<ts_PermissionArea,System_Collections_Generic.Dictionary<System.Int32,ts_DataPermission>>
  userType: Theasoft_DataTypes_Enums.UserType
  departmentWithoutReleasedRosterRights: System_Collections_Generic.HashSet<Theasoft_DataClasses_Perso.ts_DataDepartment>
  departmentWithoutReadPastRosterRights: System_Collections_Generic.HashSet<Theasoft_DataClasses_Perso.ts_DataDepartment>
  isDataService: System.Boolean
  connection: Theasoft_DataClasses_Connection.TsDBA
  deleteFlag: System.Boolean
  permission: SQLRight
  isNew: System.Boolean
  isLocked: System.Boolean
  isNewDirtyDeleteFlag: System.Boolean
  isDirty: System.Boolean
  primaryKeyValue: System.Int32
  displayValue: System.String
  createAt: System.DateTime
  createAtValue: System.String
  userCreateId: System.Nullable<System.Int32>
  lastModifiedValue: System.String
  lastModified: System.DateTime
  userModifiedId: System.Nullable<System.Int32>
  userNameModified: System.String
  userNameCreate: System.String
  userCreate: ts_DataUser
  personCreate: Theasoft_DataClasses_Personal.ts_DataPerson
  personModified: Theasoft_DataClasses_Personal.ts_DataPerson
  userModified: ts_DataUser
  classInfo: System.String
  idInfo: System.String
  createInfo: System.String
  modifiedInfo: System.String
  isDeleted: System.Boolean
  userContext: ts_DataUser
}

export type DienstplanArtenPermission = "None" | "PrintRapport" | "CloseRapport" | "RosterSumCol" | "WriteTimeAccounts" | "CanDeactivateBreakCalculation" | "CanCloseWeek" | "CanReadNotReleasedRoster" | "CanReadPastRoster" | "OpenRapport" | "CanDeactivateRegularWorkingTimeCalculation" | "EditLockedPlan"
export const DienstplanArtenPermission_AllValues = ["None", "PrintRapport", "CloseRapport", "RosterSumCol", "WriteTimeAccounts", "CanDeactivateBreakCalculation", "CanCloseWeek", "CanReadNotReleasedRoster", "CanReadPastRoster", "OpenRapport", "CanDeactivateRegularWorkingTimeCalculation", "EditLockedPlan"] as const
export const defaultDienstplanArtenPermission: DienstplanArtenPermission = "None"

export type ContactDataPermission = "None" | "ReadSecret" | "WriteQualifications" | "ReadPersonDetails" | "WritePersonDetails" | "ReadPersonBankdata" | "WritePersonBankdata" | "ReadPersonFeeNotes" | "WritePersonFeeNotes" | "WritePersonEmployee" | "ShowLinkedContacts" | "AccessPersonMemos" | "ReadAddressData" | "WriteAddressData" | "ReadContactData" | "WriteContactData" | "WritePressData" | "ReadMeasureParticipations" | "WriteMeasureParticipations"
export const ContactDataPermission_AllValues = ["None", "ReadSecret", "WriteQualifications", "ReadPersonDetails", "WritePersonDetails", "ReadPersonBankdata", "WritePersonBankdata", "ReadPersonFeeNotes", "WritePersonFeeNotes", "WritePersonEmployee", "ShowLinkedContacts", "AccessPersonMemos", "ReadAddressData", "WriteAddressData", "ReadContactData", "WriteContactData", "WritePressData", "ReadMeasureParticipations", "WriteMeasureParticipations"] as const
export const defaultContactDataPermission: ContactDataPermission = "None"

export type ts_DataPersonPermission = {
  personPermissionId: System.Int32
  personId: System.Int32
  person: Theasoft_DataClasses_Personal.ts_DataPerson
  ownerGroupId: System.Int32
  modulGroup: ts_DataOwnerGroup
  hasWritePermission: System.Boolean
  optionsFlag: ContactDataPermission
  markForDelete: System.Boolean
  isOwnPermissionGroup: System.Boolean
  connection: Theasoft_DataClasses_Connection.TsDBA
  deleteFlag: System.Boolean
  permission: SQLRight
  isNew: System.Boolean
  isLocked: System.Boolean
  isNewDirtyDeleteFlag: System.Boolean
  isDirty: System.Boolean
  primaryKeyValue: System.Int32
  displayValue: System.String
  createAt: System.DateTime
  createAtValue: System.String
  userCreateId: System.Nullable<System.Int32>
  lastModifiedValue: System.String
  lastModified: System.DateTime
  userModifiedId: System.Nullable<System.Int32>
  userNameModified: System.String
  userNameCreate: System.String
  userCreate: ts_DataUser
  personCreate: Theasoft_DataClasses_Personal.ts_DataPerson
  personModified: Theasoft_DataClasses_Personal.ts_DataPerson
  userModified: ts_DataUser
  classInfo: System.String
  idInfo: System.String
  createInfo: System.String
  modifiedInfo: System.String
  isDeleted: System.Boolean
  userContext: ts_DataUser
}

export type TheasoftProduct = "theaDispo" | "theaPerso" | "theaChor" | "theaExport" | "theaContract" | "theaBudget" | "theaContact" | "theaBallett" | "theaOrchester" | "theaWorks" | "theaTransfer" | "ProductionChart" | "theaLibrary" | "theaDispoWeb" | "theaOrchesterWeb" | "theaOrder" | "theaTravel" | "theaPersoWeb" | "theaContactWeb" | "theaStatisterie" | "theaStaff" | "theaCostume" | "theaMaskWeb" | "theaMask" | "theaFund" | "theaDispoWebManager" | "theaDispoWebUser" | "theaPersoWebManager" | "theaPersoWebUser" | "theaOrchesterWebManager" | "theaOrchesterWebUser" | "theaWebWorkAreaUser" | "theaInventory" | "theaInventoryWeb" | "theaFundWeb" | "theaOrchesterWebWorkAreaUser"
export const TheasoftProduct_AllValues = ["theaDispo", "theaPerso", "theaChor", "theaExport", "theaContract", "theaBudget", "theaContact", "theaBallett", "theaOrchester", "theaWorks", "theaTransfer", "ProductionChart", "theaLibrary", "theaDispoWeb", "theaOrchesterWeb", "theaOrder", "theaTravel", "theaPersoWeb", "theaContactWeb", "theaStatisterie", "theaStaff", "theaCostume", "theaMaskWeb", "theaMask", "theaFund", "theaDispoWebManager", "theaDispoWebUser", "theaPersoWebManager", "theaPersoWebUser", "theaOrchesterWebManager", "theaOrchesterWebUser", "theaWebWorkAreaUser", "theaInventory", "theaInventoryWeb", "theaFundWeb", "theaOrchesterWebWorkAreaUser"] as const
export const defaultTheasoftProduct: TheasoftProduct = "theaDispo"

export type TheasoftLicenseType = "ViewLicense" | "FullLicense"
export const TheasoftLicenseType_AllValues = ["ViewLicense", "FullLicense"] as const
export const defaultTheasoftLicenseType: TheasoftLicenseType = "ViewLicense"


